<!-- youtube-mobile-04 preview — YouTube watch page, square image in-stream ad -->
<app-mobile-frame>
  <!-- START: Player -->
  <a class="yt-m-stream d-block" [href]="data.url || null" target="_blank" rel="noopener noreferrer" frameTop>
    <ng-container *ngIf="creativeImage; else missing">
      <img class="yt-m-stream-blur" [src]="creativeImage" alt="" />
      <img class="yt-m-stream-image" [src]="creativeImage" alt="" />
    </ng-container>
    <ng-template #missing>
      <div class="yt-m-stream-missing">{{ missingDimensionLabel }}</div>
    </ng-template>

    <span class="yt-m-stream-channel d-flex flex-row align-items-center gap-2">
      <img
        class="yt-m-stream-channel-logo"
        src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
        alt=""
      />
      <span class="d-flex flex-column">
        <strong>Valamar</strong>
        <small>3,31 tis. pretplatnika</small>
      </span>
    </span>
    <span class="yt-m-stream-title">{{ data.longHeadlines[0] || data.headlines[0] || "Your headline appears here" }}</span>
    <span class="yt-m-stream-visit">Visit advertiser <i class="bi bi-info-circle"></i></span>

    <span class="yt-m-stream-play"><i class="bi bi-play-fill"></i></span>

    <span class="yt-m-stream-sponsored d-flex flex-column align-items-start gap-1">
      <span class="yt-m-stream-link"><i class="bi bi-link-45deg"></i></span>
      <span>Sponsored <i class="bi bi-info-circle"></i></span>
    </span>
    <span class="yt-m-stream-watch">Gledajte na <strong><i class="bi bi-youtube"></i> YouTube</strong></span>
    <span class="yt-m-stream-progress"></span>
  </a>
  <!-- END: Player -->

  <!-- START: Feed -->
  <div class="yt-m-feed">
    <!-- START: Real ad -->
    <div class="yt-m-card yt-m-bar-row d-flex flex-row align-items-center gap-2">
      <img
        class="yt-m-avatar"
        src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
        alt=""
      />
      <div class="yt-m-info-text">
        <h4 class="yt-m-row-title">{{ data.headlines[0] || "Your headline appears here" }}</h4>
        <div class="yt-m-meta"><strong>Sponsored</strong> &middot;</div>
      </div>
      <i class="bi bi-three-dots-vertical yt-m-more align-self-center"></i>
      <a [href]="data.url || null" target="_blank" rel="noopener noreferrer" class="yt-m-pill-cta">
        {{ data.ctaText || "Your call to action" }}
      </a>
    </div>
    <!-- END: Real ad -->

    <!-- START: Skeleton -->
    <div class="yt-m-card yt-m-skel-block d-flex flex-column gap-2" aria-hidden="true">
      <span class="yt-m-skel yt-m-skel-line"></span>
      <span class="yt-m-skel yt-m-skel-line w-50"></span>
      <span class="d-flex flex-row align-items-center gap-2 mt-2">
        <span class="yt-m-skel yt-m-skel-dot"></span>
        <span class="yt-m-skel yt-m-skel-line yt-m-skel-name"></span>
        <span class="yt-m-skel yt-m-skel-pill ms-auto"></span>
      </span>
      <span class="d-flex flex-row gap-2 mt-2">
        <span *ngFor="let c of chips" class="yt-m-skel yt-m-skel-chip"></span>
      </span>
      <span class="yt-m-skel yt-m-skel-box mt-2"></span>
    </div>
    <!-- END: Skeleton -->

    <!-- START: Video placeholder -->
    <div class="yt-m-card yt-m-filler" aria-hidden="true">
      <img class="yt-m-filler-image" src="/assets/images/youtube-placeholder-video.png" alt="" />
      <div class="yt-m-filler-meta d-flex flex-row align-items-center gap-2">
        <span class="yt-m-skel yt-m-skel-dot"></span>
        <span class="yt-m-skel yt-m-skel-line flex-grow-1"></span>
      </div>
    </div>
    <!-- END: Video placeholder -->
  </div>
  <!-- END: Feed -->
</app-mobile-frame>
